import track from './track';
import queryparse from 'tricks/string/queryparse';

// Track notification nudges

const {utm_source, utm_medium} = queryparse(document.location.search);

if (!isNaN(utm_source)) {
	track('message', 'open', utm_medium || '', utm_source);
}
